export const IBM_TABLES = {
    CER002: 'CER002', //Vendedores
    CERoo7: 'CERoo7', //Compradores
    CER019: 'CER019', //Corredoras del vendedor
    /*CER225: 'CER225', //VER
    CERCANJ: 'CERCANJ', //VER
    CCLOCA: 'CCLOCA', //VER
    CERCALI: 'CERCALI', //LISTO*/
    CER050TC: 'CER050TC',
}